"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.renderMarkdown = renderMarkdown;
const markdown_it_1 = __importDefault(require("markdown-it"));
/**
 * The Markdown subset legal sections may use.
 *
 * ⚠️ **`html: false` is the security control, not a formatting preference.**
 * markdown-it passes raw HTML straight through when it is enabled, so leaving
 * the default on would reintroduce exactly the stored-XSS hole that not
 * accepting HTML uploads was meant to avoid — an admin could paste a `<script>`
 * into a section body and we would serve it from our own origin.
 *
 * ⚠️ **The subset is a contract between renderers, which is why it lives in
 * `shared` rather than beside either one.** The API renders the store page from
 * it and the admin panel previews the draft with it; a second copy would let
 * the preview and the published page disagree about what an admin just wrote.
 * The mobile app draws the same Markdown natively.
 * Anything supported here that the app cannot draw makes the store page and the
 * in-app page show different things — the drift a shared source exists to
 * prevent. Bold, italic, links and lists only:
 *
 *   · no images or tables — the app has no card component for either
 *   · no code blocks — legal text has no use for them
 *   · no headings — a section already carries its own, and a nested `##` would
 *     produce two competing hierarchies in the same card
 *
 * Disabled rules fall back to being rendered as plain text rather than
 * throwing, so an admin who pastes a table sees their pipes rather than a
 * broken page.
 */
const renderer = new markdown_it_1.default('zero', {
    html: false,
    // Bare URLs are NOT auto-linked. An address written in prose ("write to
    // privacy@…") would otherwise become a link the author never asked for.
    linkify: false,
    breaks: false,
}).enable([
    'emphasis',
    'link',
    'list',
    'paragraph',
    'newline',
    'text',
    'escape',
    'entity',
    'normalize',
    'block',
    'inline',
]);
/**
 * ⚠️ Every link gets `rel="noopener noreferrer"` and opens in a new tab.
 *
 * The store page is a standalone document with no navigation of its own, so a
 * link that replaced it would strand a reviewer on a page with no way back.
 * `noopener` is the part that matters though: without it the opened page can
 * reach back through `window.opener`.
 *
 * markdown-it already refuses `javascript:` and `data:` URLs through its own
 * `validateLink`, which is why that is not re-implemented here.
 */
const defaultLinkOpen = renderer.renderer.rules.link_open ??
    ((tokens, idx, options, _env, self) => self.renderToken(tokens, idx, options));
renderer.renderer.rules.link_open = (tokens, idx, options, env, self) => {
    tokens[idx]?.attrSet('rel', 'noopener noreferrer');
    tokens[idx]?.attrSet('target', '_blank');
    return defaultLinkOpen(tokens, idx, options, env, self);
};
/** Renders one section body to HTML for the store page. */
function renderMarkdown(body) {
    return renderer.render(body);
}
//# sourceMappingURL=legal-markdown.js.map